import React, { useMemo } from 'react'
import injectSheet from 'react-jss'
import styles from './slide.styles'
import Slide from '../../../components/slide/slide.jsx'
import Guides from './guides/guides.jsx'
import Lines from './lines/lines.jsx'
import { withPresentation } from '../../../presentation-connectors'

const LINE_TYPE = {
  blank: () => null,
  guides: props => <Guides {...props} />,
  lines: props => <Lines {...props} />
}

const BlankSlide = ({ classes, slides, id }) => {
  const data = slides[id]

  const slideData = useMemo(
    () => ({
      lineType: data.line_type,
      lineHeight: data.line_height
    }),
    [data]
  )

  return (
    <Slide className={classes.container}>
      {LINE_TYPE[slideData.lineType]({ lineHeight: slideData.lineHeight })}
    </Slide>
  )
}

export default withPresentation(injectSheet(styles)(BlankSlide))
